import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { permittedCourseIds } from '../data/courseRegistry';
import { installCatalog } from '../data/academicCatalog';
import { installLegacyCards } from '../data/flashcards';
import { installLegacyQuestions } from '../data/questoes';
import { loadAuthorizedCatalog } from '../services/catalogService';
import { installQuickPhrases } from '../data/revisaoRapida';

const Context=createContext({ revision:0 });
export const useCatalog=()=>useContext(Context);
export function CatalogProvider({children}) {
  const {usuario,perfil}=useAuth();
  const [state,setState]=useState({key:'',revision:0,error:''});
  const [reload,setReload]=useState(0);
  const ids=permittedCourseIds(perfil), admin=!!(perfil?.isAdmin||perfil?.role==='admin');
  const key=`${usuario?.uid||''}:${admin}:${ids.join(',')}:${reload}`;
  useEffect(()=>{
    let active=true;
    installCatalog();installLegacyCards([]);installLegacyQuestions([]);installQuickPhrases([]);
    if(!usuario || !perfil) { setState(previous=>({...previous,key,error:''}));return; }
    loadAuthorizedCatalog(ids,admin).then(data=>{
      if(!active)return;
      installCatalog(data);installLegacyCards(data.legacyCards);installLegacyQuestions(data.legacyQuestions);installQuickPhrases(data.legacyPhrases);
      setState(previous=>({key,revision:previous.revision+1,error:''}));
    }).catch(()=>{if(active)setState(previous=>({...previous,key,error:'Não foi possível carregar seus conteúdos autorizados. Seu histórico foi preservado.'}));});
    return()=>{active=false;};
  },[key]);
  useEffect(()=>{const changed=()=>setReload(n=>n+1);window.addEventListener('pruvenx:catalog-updated',changed);return()=>window.removeEventListener('pruvenx:catalog-updated',changed);},[]);
  if(usuario&&perfil&&state.key!==key)return <div className="page" role="status">Carregando seus cursos autorizados…</div>;
  if(state.error)return <div className="page" role="alert"><p>{state.error}</p><button className="btn btn-primary" onClick={()=>setReload(n=>n+1)}>Tentar novamente</button></div>;
  return <Context.Provider value={{revision:state.revision}}>{children}</Context.Provider>;
}
